import { useGenomeViewerStore } from "../../store/store.ts";
import type { MiniFamily } from "../../synteny-worker/state.ts";
import type { TrackGroups, Tracks } from "../../types.ts";

export function removeTracks<T extends Tracks, G extends TrackGroups, F extends MiniFamily>(
  trackDeletions: { trackId: string; groupId: string }[] = [],
  { tracks, trackGroups, alignedFamily }: { tracks: T; trackGroups: G; alignedFamily?: F },
  removeEmptyGroup = false,
): { tracks: T; trackGroups: G; alignedFamily?: F } {
  const { busyList, waitingList } = useGenomeViewerStore.getState();

  for (const { trackId, groupId } of trackDeletions) {
    const track = tracks.get(trackId);
    const trackGroup = trackGroups.get(groupId);

    if (!trackGroup || !track) {
      continue;
    }

    const trackIds = trackGroup?.trackIds ?? [];
    track.worker.terminate();
    tracks.delete(trackId);
    busyList.delete(trackId);
    waitingList.delete(trackId);

    const newTrackIds = trackIds.filter((id) => id !== trackId);

    if (newTrackIds.length === 0 && removeEmptyGroup) {
      trackGroups.delete(groupId);
    } else {
      trackGroups.set(groupId, { ...trackGroup, trackIds: newTrackIds });
    }

    if (alignedFamily) {
      // remove members of deleted tracks
      alignedFamily.members = alignedFamily.members.filter((member) => member.trackId !== trackId);
    }
  }

  // Do not return alignedFamily if any to not overwrite it in the update
  if (alignedFamily) {
    return { trackGroups, tracks, alignedFamily };
  }

  return { trackGroups, tracks };
}
